import { useParams } from "react-router-dom";

const TrackOrder = () => {
  const { orderId } = useParams();
  return <div>Tracking info for Order {orderId}</div>;
};

export default TrackOrder;
